<template>
	<div v-if="albums">
		<nk-wrapper spacing="lg">
			<nk-row gutter="2" vertical-gutter="2">
				<template v-for="(album, index) in albums">
					<nk-col
						v-if="album.title"
						:key="`album-${index}`"
						cols="full"
						sm="6/12"
						xl="4/12"
					>
						<div>
							<nk-card
								:grouped="false"
								:title="`Bildergalerie ${album.title} öffnen`"
								role="button"
							>
								<template #header>
									<nk-image
										ref="coverImage"
										:src="album.coverPhotoBaseUrl"
										:alt="album.title"
										:lightbox="`light-${index}`"
										ar="4:3"
										:gallery="mediaItems[index]"
										@lightbox-opened="openCoverLightbox(index)"
									/>
								</template>
								<template #body>
									<div>
										<nk-meta>
											{{ album.mediaItemsCount }}
											{{ album.mediaItemsCount > 1 ? 'Bilder' : 'Bild' }}
										</nk-meta>
										<a
											href="#"
											@click.prevent="openCoverLightbox(index, $event)"
										>
											<nk-title tag="h2" size="lg">
												{{ album.title }}
											</nk-title>
										</a>
									</div>
								</template>
							</nk-card>
						</div>
					</nk-col>
				</template>
			</nk-row>
			<nk-wrapper>
				<nk-row
					v-if="context.nextPageToken && nextPageToken !== false"
					justify-content="center"
				>
					<nk-col cols="shrink">
						<nk-button :is-loading="isNextAlbumLoading" @click="loadNextAlbums">
							Weitere Bildergalerien laden
						</nk-button>
					</nk-col>
				</nk-row>
			</nk-wrapper>
		</nk-wrapper>
	</div>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {object} context.albums
 * @prop {string} context.albums
 * @prop {string} options.nextPageSize
 */
export default {
	name: 'NkTemplateBildergalerien',

	mixins: [TemplatesDefault],

	data() {
		return {
			isNextAlbumLoading: false,
			nextPageToken: null,
			albums: [],
			mediaItems: {},
		};
	},

	created() {
		this.albums = this.context.albums;
	},

	methods: {
		async openCoverLightbox(index, event) {
			if (event) this.$refs.coverImage[index].openLightbox(event);

			if (this.mediaItems[index]) return;

			const mediaItemsData = await this.$getApiData({
				endpoint: `/api/albums/mediaItems/${this.albums[index].id}`,
			});

			const galleryItems = mediaItemsData.mediaItems.map(item => {
				return {
					bild: item.baseUrl,
					bildtext: item.filename,
				};
			});

			this.$set(this.mediaItems, index, galleryItems);
		},
		async loadNextAlbums() {
			try {
				this.isNextAlbumLoading = true;
				const nextAlbumsData = await this.$getApiData({
					endpoint: '/api/albums',
					params: {
						nextPageToken: this.nextPageToken || this.context.nextPageToken,
						pageSize: this.options.nextPageSize || 6,
					},
				});

				this.albums = [...this.albums, ...nextAlbumsData.albums];
				this.nextPageToken = nextAlbumsData.nextPageToken || false;
			} finally {
				this.isNextAlbumLoading = false;
			}
		},
	},
};
</script>
